export const ASPEN_SITECODES = [
  'ASPEN',
  'Santos Ballera (Cooper Basin)',
  'Santos Tanumbririni',
  'Shell Prelude',
  'Shell Magnetic 1',
  'Origin Spring Gully',
  'Origin Talinga',
  'Paringa',
  'Santos Arcadia (Surat Basin)',
  'Santos Cattle Creek',
  'Santos Devil Creek',
  'Santos DLNG (Darwin Harbour)',
  'Santos Fairview (Surat Basin)',
  'Santos GLNG',
  'Santos Moomba (Cooper Basin)',
  'Santos Narrabri',
  'Santos Ningaloo Vision',
  'Santos Roma East (Surat Basin)',
  'Santos Scotia',
  'Santos Varanus Island',
  'Shell Charlie',
  'Shell Chinchilla',
  'Shell Curtis Island',
  'Shell Kenya',
  'Shell Ruby Jo',
  'Shell Windibri',
  'Shell Woleebee Creek',
  'Terrex',
  'Bechtel Project',
  'Evolution Ernest Henry',
  'Evolution Lake Cowal',
  'Evolution Mt Carlton',
  'Origin Reedy Creek',
  'Evolution Mt Rawdon',
  'Evolution Mungari',
  'Origin Bungaroo',
  'Origin Condabri',
  'Origin Eraring Power Station',
  'Origin Gangarri',
  'Origin Kyalla (Beetaloo)',
];

export const ASPEN_SITECODE = 'ASPEN';

export const SPECIAL_SITECODES = ['FU123 - Followup', 'CALLBACK'];

export const INVALID_CHARACTERS = [' ', ':', '*', '?', '!', '#', '@', '$'];
